import { render, staticRenderFns } from "./ItemWritePremiumMarketAddLayout.vue?vue&type=template&id=b9564748&scoped=true&"
import script from "./ItemWritePremiumMarketAddLayout.vue?vue&type=script&lang=js&"
export * from "./ItemWritePremiumMarketAddLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9564748",
  null
  
)

export default component.exports